// Live field status on a view's page (guide 19.7): when anyone sets a
// status on this view, the project's event stream (GET /issue/events,
// server-sent events) says which view and rows changed, and the page re-reads
// their states - the sheets and the tracking table recolour without a reload.
// A burst (a bulk change) is one re-read. EventSource reconnects by itself.
import { useEffect, useRef } from "react";
import { url, tokenRef } from "api";

export function isForView(payload, viewId) {
  return !!payload && payload.type === "tracking_status" && payload.viewId === viewId;
}

export function useTrackingEvents(projectId, viewId, onChange, { delay = 400 } = {}) {
  const cb = useRef(onChange);
  cb.current = onChange;
  useEffect(() => {
    if (!projectId || !viewId || typeof window === "undefined" || typeof window.EventSource === "undefined") return undefined;
    let timer = null;
    let es = null;
    try {
      const token = localStorage.getItem(tokenRef) || "";
      es = new window.EventSource(`${url}/issue/events?projectId=${encodeURIComponent(projectId)}&token=${encodeURIComponent(token)}`);
      es.onmessage = (e) => {
        let payload = null;
        try { payload = JSON.parse(e.data); } catch (err) { return; }
        if (!isForView(payload, viewId)) return;
        clearTimeout(timer);
        timer = setTimeout(() => cb.current(payload), delay);
      };
    } catch (e) { /* no live updates; the page still works on reload */ }
    return () => { clearTimeout(timer); if (es) es.close(); };
  }, [projectId, viewId, delay]);
}
